import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { DriveManagerPage } from '@/features/drive-permissions-manager/components/DriveManagerPage';

export const Route = createFileRoute('/_authenticated/drive-manager')({
  beforeLoad: () => requireFeature(FeatureKey.GOOGLE_WORKSPACE),
  component: DriveManagerRoute,
});

function DriveManagerRoute() {
  return (
    <PermissionGate permission={Permission.DRIVE_MANAGER_MANAGE}>
      <DriveManagerPage />
    </PermissionGate>
  );
}
